import { isNil } from '@/utils/isNil';
import { FC, ReactNode } from 'react';

import { IconArrowUp } from 'src/general/Icons/IconArrowUp';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';

import styles from './CheckoutDescription.module.scss';

interface CheckoutDescriptionProps {
  title: ReactNode;
  description?: ReactNode;
  onBack?: () => void;
}

export const CheckoutDescription: FC<CheckoutDescriptionProps> = ({ title, description, onBack }) => (
  <section className={styles.wrapper}>
    <div className={styles.titleGroup}>
      <h3 className={styles.title} data-testid="checkout-description-title">
        {title}
      </h3>
      {!isNil(onBack) && (
        <ButtonIcon
          Icon={IconArrowUp}
          title="Back"
          variant="secondary"
          size="small"
          onClick={onBack}
          data-testid="CHECKOUT_BACK_BUTTON"
        />
      )}
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </section>
);
